<script>
    import SubBasic from './sub/subBasic.svelte'
    import SubSkill from './sub/subSkill.svelte'

    export let Position, Monster, ActiveTab, DataCheck

    function onClickTab(_tab) {
        ActiveTab = _tab
    }
</script>

<div class="menu">
    {#if Monster.equipment != undefined}
        <div class="tab top"
            class:active={ActiveTab == 1}
            on:click={() => onClickTab(1)}
        >
            기본
        </div>
    {/if}

    {#if Monster.skills[0].length > 0}
        <div class="tab middle"
            class:active={ActiveTab == 2}
            on:click={() => onClickTab(2)}
        >
            액티브
        </div>
    {/if}
    
    {#if Monster.skills[1].length > 0}
        <div class="tab bottom"
            class:active={ActiveTab == 3}
            on:click={() => onClickTab(3)}
        >
            패시브
        </div>
    {/if}
</div>

{#if typeof Monster == 'object'}
    <div class="inputPage">
        {#if ActiveTab == 1}
                <SubBasic
                    bind:Position
                    bind:Equipment={Monster.equipment}
                />
        {:else if ActiveTab == 2}
            <SubSkill
                bind:Position
                bind:Monster={Monster.num}
                Section={0}
                bind:Skills={Monster.skills[0]}
                bind:DataCheck
            />
        {:else if ActiveTab == 3}
            <SubSkill
                bind:Position
                bind:Monster={Monster.num}
                Section={1}
                bind:Skills={Monster.skills[1]}
                bind:DataCheck
            />
        {/if}
    </div>
{/if}

<style lang="scss">
    
    .menu {
        display: inline-block;

        .tab {
            background: $cl2;
            width: fit-content;
            height: fit-content;
            padding: 10px 6px;
            color: $cl3;
            font-size: 14px;
            font-family: aggro;
            writing-mode: vertical-lr;

            &.active {
                background: $cl3;
                color: $cl2;
            }

            &:hover:not(.active) {
                background: $cl3;
                color: $cl2;
                cursor: pointer;
            }
        }
    }
    
        
    .inputPage {
        width: calc(100% - 40px - 4px - 35px);
        height: fit-content;
        min-height: calc(196px - 20px - 4px);
        padding: 20px;
        padding-bottom: 0;
        border: 2px solid $cl3;
        display: inline-block;
        vertical-align: top;
    }
</style>